const appRoles = {
  ADMIN: {
    name: 'Administrador',
    description: 'Cria, edita e aprova pagamentos',
    value: 'ADMIN'
  },
  OPERATOR: {
    name: 'Operador',
    description: 'Cria, edita e envia para aprovação',
    value: 'OPERATOR'
  },
  ANALYST: {
    name: 'Analista',
    description: 'Apenas visualiza pagamentos, comprovantes e indicadores',
    value: 'ANALYST'
  }
};

const appRolesKeys = {};
Object.keys(appRoles).forEach(role => {
  appRolesKeys[role] = appRoles[role].value;
});
appRolesKeys.ALL = Object.keys(appRoles).map(key => appRoles[key].value);

module.exports = appRoles;
module.exports.appRolesKeys = appRolesKeys;
